import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function ReLayoutWarningModal({ show, onClose, onConfirm, positions }) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Повторная передача на компоновку</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Вы пытаетесь повторно передать на компоновку позиции, которые уже имеют статус,
          отличный от <b>Новый</b> или <b>Неизвестно</b>.
        </p>

        <p>Количество таких позиций: <b>{positions.length}</b></p>

        <ul>
          {positions.map(p => (
            <li key={p.id}>
              {p.article} — статус: <b>{p.status}</b>
            </li>
          ))}
        </ul>

        <p>Вы уверены, что хотите продолжить?</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Отмена
        </Button>
        <Button variant="warning" onClick={onConfirm}>
          Передать на компоновку
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
